import { render, staticRenderFns } from "./DocflowRegisterForm.vue?vue&type=template&id=cdb942ac&"
import script from "./DocflowRegisterForm.vue?vue&type=script&lang=js&"
export * from "./DocflowRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports